var _rect, _path, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDefaultProgramIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    fill: "#cccccc",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    rx: 10,
    fill: "#f0f0f0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50 25 L75 45 L75 75 L25 75 L25 45 Z M50 50 L65 60 L65 70 L35 70 L35 60 Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 35,
    r: 8,
    fill: "#cccccc"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultProgramIcon);
export default __webpack_public_path__ + "static/media/default-program-icon.05eb08eccb3feaf376a4bd8fea117bda.svg";
export { ForwardRef as ReactComponent };